import { render, staticRenderFns } from "./ProjectBidding.vue?vue&type=template&id=76069896"
import script from "./ProjectBidding.vue?vue&type=script&lang=js"
export * from "./ProjectBidding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports